import { render } from "./VsudSwitch.vue?vue&type=template&id=18fc6d47"
import script from "./VsudSwitch.vue?vue&type=script&lang=js"
export * from "./VsudSwitch.vue?vue&type=script&lang=js"

import exportComponent from "E:\\LARAVEL\\diariodetreino pastas\\front\\diariodetreino-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__